import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Position extends EntityDto implements IEntityDto {
    Position_Id: string;
    PositionName: string; 
    Code:string;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Position_Id = "00000000-0000-0000-0000-000000000000";
        this.PositionName = ""; 
        this.Code ="";
        this.TotalCount = 0;
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'PositionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Position Name is required' },
           { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
        ];
    }
}
